import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/DownloadApp.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";

import designImageSrc from "images/pen-tool-vector-curve-icon.png";
import decorationImageSrc from "images/kitchen-color-icon.png";
import customerSupportIconImageSrc from "images/customer-support-illustration.svg";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl`;
  return (
    <AnimationRevealPage>
      <Hero
        heading={<>優雅、時尚 <HighlightedText>為您打造完美空間</HighlightedText></>}
        description="我們專注於創造獨特的室內設計方案，將您的理想居所變為現實。從概念設計到施工完成，我們的專業團隊將全程為您服務。"
        imageSrc="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="預約諮詢"
        watchVideoButtonText="觀看案例"
      />
      <MainFeature
        subheading={<Subheading>創立於2014年</Subheading>}
        heading={
          <>
            專業服務
            <wbr /> <HighlightedText>超過10年</HighlightedText>
          </>
        }
        description={
          <Description>
            我們擁有豐富的室內設計經驗，為數千個家庭打造理想的生活空間。我們的設計理念融合現代美學與實用性，讓每個角落都充滿溫度與品味。
            <br />
            <br />
            從小坪數到豪宅大宅，我們都能為您提供最適合的設計方案，讓您的居所既實用又時尚。
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="查看作品集"
        imageSrc={
          "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <TabGrid id="showcase"
        heading={
          <>
            瀏覽我們的 <HighlightedText>設計及工程</HighlightedText>
          </>
        }
      />
      <Features
        heading={
          <>
            完善的 <HighlightedText>服務項目</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: designImageSrc,
            title: "空間規劃",
            description: "專業的空間規劃，讓您的居所更加舒適實用",
            url: "https://google.com"
          },
          {
            imageSrc: decorationImageSrc,
            title: "材質選搭",
            description: "優質建材搭配，確保居家品質與美感",
            url: "https://timerse.com"
          },
          {
            imageSrc: customerSupportIconImageSrc,
            title: "施工監管",
            description: "嚴格的施工品質控管，讓您安心放心",
            url: "https://reddit.com"
          }
        ]}
        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      <MainFeature2
        subheading={<Subheading>值得信賴的室內設計工程</Subheading>}
        heading={<>為何選擇 <HighlightedText>萬匠裝修工程 ?</HighlightedText></>}
        description="我們擁有專業且經驗豐富的團隊，能夠提供高質量的服務，從設計、選材到施工都一絲不苟，確保每個細節符合您的需求。我們注重與客戶的溝通，提供個性化建議和解決方案，讓您感到放心。此外，我們在施工過程中保持高效和有序，能夠及時解決問題，並提供優質的售後服務。選擇萬匠裝修工程，您將得到一個美觀實用的居住空間，並享受專業細心的服務。希望這些理由能幫助您做出決定。"
        statistics={[
          {
            key: "完工案例",
            value: "50+"
          },
          {
            key: "工程時間",
            value: "< 6 個月"
          },
          {
            key: "團隊人數",
            value: "30+"
          }
        ]}
        primaryButtonText="WhatsApp 聯絡"
        primaryButtonUrl="https://wa.me/85270719668"
        imageInsideDiv={false}
        imageSrc="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEzNzI2fQ&auto=format&fit=crop&w=768&q=80"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />
      <Testimonial
        subheading=""
        heading={<>客戶 <HighlightedText>評價</HighlightedText></>}
      />
      {/* <DownloadApp
        text={<>立即下載我們的 <HighlightedTextInverse>設計APP</HighlightedTextInverse> 查看更多案例</>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
}
